const imagesLoader = {
    "sieges": require.context("./assets/images/sieges", false, /\.webp$/),
    "abat-jour": require.context("./assets/images/abat-jour", false, /\.webp$/),
    "coussins": require.context("./assets/images/coussins", false, /\.webp$/),
}

export default imagesLoader;